export const SubBtn = ({ text, onClick }) => {
  return (
    <div className='btn-02' style={{ marginBottom: '30px' }}>
      <div onClick={onClick}>
        <span>{text}</span>
      </div>
    </div>
  );
};
